export default __webpack_public_path__ + "static/media/not-found.abdd0afe.svg";